import React from 'react';

const Image = React.forwardRef(function WishImage({ image, id }, ref) {
  return (
    <div className={'wish__image'} ref={ref}>
      <img src={image} className={'wish__image-img'} alt={''} />
    </div>
  );
});
export default Image;
Image.propTypes = {};
